// extracted by mini-css-extract-plugin
export var content = "layout-module--content--j6d7Q";